import { render, staticRenderFns } from "./ZgbTeamMembersEdit.vue?vue&type=template&id=a542c2e8"
import script from "./ZgbTeamMembersEdit.vue?vue&type=script&lang=js"
export * from "./ZgbTeamMembersEdit.vue?vue&type=script&lang=js"
import style0 from "./ZgbTeamMembersEdit.vue?vue&type=style&index=0&id=a542c2e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports